var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", [_vm._v("Version 0.1")]),
      _c("p", [_vm._v("2019-06-07")]),
      _c("div", { staticClass: "alert alert-info" }, [
        _c("h3", [_vm._v("Initial release")]),
        _c("hr"),
        _c("p", [_c("b", [_vm._v("Major Features:")])]),
        _c("ul", [
          _c("li", [_vm._v("Upload a mapping spreadsheet")]),
          _c("li", [_vm._v("Automated QA")]),
          _c("ul", [
            _c("li", [
              _vm._v("Check spreadsheet for required tabs and columns")
            ]),
            _c("li", [_vm._v("Check Type tab")]),
            _c("ul", [
              _c("li", [_vm._v("Check for valid mapping codes")]),
              _c("li", [_vm._v("Checks for add operations")]),
              _c("ul", [
                _c("li", [_vm._v("Target namespace prefix checks")]),
                _c("ul", [_c("li", [_vm._v("Missing namespace prefix")])]),
                _c("li", [_vm._v("Target name checks")]),
                _c("ul", [
                  _c("li", [_vm._v("Missing name")]),
                  _c("li", [
                    _vm._v(
                      "Type name does not end with representation term 'Type'"
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Simple type with name that does not end with 'SimpleType'"
                    )
                  ]),
                  _c("li", [
                    _vm._v("Complex type with name that ends with 'SimpleType'")
                  ]),
                  _c("li", [
                    _vm._v(
                      "Simple type with name that ends with 'CodeSimpleType' but does not declare enumerations in the 'Code/Facets' tab"
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Type with name that ends with 'CodeType' that does not have a base type with a name that ends with 'CodeSimpleType'"
                    )
                  ]),
                  _c("li", [_vm._v("Duplicate type names in spreadsheet")]),
                  _c("li", [
                    _vm._v(
                      "Warning for use of term 'Type' outside of final representation term for type name"
                    )
                  ])
                ]),
                _c("li", [_vm._v("Target definition checks")]),
                _c("ul", [
                  _c("li", [_vm._v("Missing definition")]),
                  _c("li", [
                    _vm._v('Definition does not begin with "A data type "')
                  ])
                ]),
                _c("li", [_vm._v("Target style checks")]),
                _c("ul", [
                  _c("li", [_vm._v("Simple or CSC type without a base type")]),
                  _c("li", [
                    _vm._v("Simple type without a XML schema base type")
                  ])
                ])
              ])
            ]),
            _c("li", [_vm._v("Check Code/Facet tab")]),
            _c("ul", [
              _c("li", [_vm._v("Check for valid mapping codes")]),
              _c("li", [_vm._v("Checks for add operations")]),
              _c("ul", [
                _c("li", [_vm._v("Target type checks")]),
                _c("ul", [
                  _c("li", [_vm._v("Missing name")]),
                  _c("li", [_vm._v("Type name is not defined in the Type tab")])
                ]),
                _c("li", [_vm._v("Target value checks")]),
                _c("ul", [_c("li", [_vm._v("Missing value")])]),
                _c("li", [_vm._v("Target definition checks")]),
                _c("ul", [_c("li", [_vm._v("Missing definition")])]),
                _c("li", [_vm._v("Target kind checks")]),
                _c("ul", [_c("li", [_vm._v("Invalid facet kind")])])
              ])
            ])
          ]),
          _c("li", [_vm._v("View results table")]),
          _c("li", [_vm._v("Download results spreadsheet")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }